/* eslint-disable no-nested-ternary */
/* eslint-disable default-case */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import ContentWrapper from '../Layout/ContentWrapper';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Row, Col, Button } from 'reactstrap';
import FormModal from './FormModal';
import { useTranslation } from 'react-i18next';
import Spinner from './Spinner';

function DataTable({
  title = null,
  columns = null,
  data = [],
  fulldata = {},
  getPage = null,
  hasAdd = false,
  loading = false,
  textButton = null,
  link = null,
}) {
  const [pagination, setPagination] = useState({
    page: 0,
    count: 1,
  });
  const [hasModal, setHasModal] = useState(false);
  const [term, setTerm] = useState(undefined);
  const [isEditable, setIsEditable] = useState(false);
  const { t } = useTranslation();
  let timeout = null;
  const history = useHistory();

  useEffect(() => {
    if (term === undefined) {
      getPage(pagination.page + 1, term);
    } else {
      timeout = setTimeout(() => getPage(pagination.page + 1, term), 400);
    }
    return () => clearTimeout(timeout);
  }, [pagination.page, term]);

  useEffect(() => {
    if (title === t('users.users')) {
      setHasModal(true);
    } else if (hasAdd) {
      setIsEditable(true);
    }
  }, []);

  const getMuiTheme = () =>
    createMuiTheme({
      palette: {
        primary: {
          main: '#1DA0D0',
        },
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: { backgroundColor: 'transparent !important', color: 'inherit' },
        },
      },
    });

  const options = {
    filter: !hasModal,
    search: !hasModal,
    viewColumns: !hasModal,
    sort: false,
    filterType: 'dropdown',
    responsive: 'vertical',
    download: false,
    print: false,
    elevation: 1,
    serverSide: true,
    pagination: true,
    count: fulldata.totalDocs,
    rowsPerPage: 10,
    rowsPerPageOptions: [10],
    page: pagination.page,
    selectableRowsHideCheckboxes: true,
    selectableRowsOnClick: false,
    selectableRowsHeader: false,
    textLabels: {
      body: {
        noMatch: loading ? (
          <Spinner style={{ height: 10 }} />
        ) : (
          t('common.noMatchingData')
        ),
      },
    },
    searchPlaceholder: t('common.searchData'),
    onSearchChange: (searchText) => {
      setTerm(searchText);
    },
    setRowProps: (row, dataIndex) => {
      if (dataIndex % 2 === 0) {
        return { style: { backgroundColor: '#FAFBFC' } };
      }
      return null;
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          setPagination({ page: tableState.page });
          break;
        case 'changeRowsPerPage':
          setPagination({ count: tableState.rowsPerPage });
          break;
      }
    },
  };

  return (
    <ContentWrapper>
      <div className="d-flex justify-content-between content-heading">
        <p>{title}</p>
        <div>
          {hasModal ? (
            <FormModal />
          ) : isEditable ? (
            <Button
              onClick={() => history.push(link)}
              color="info"
              className="btn-labeled"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <span className="btn-label">
                <i className="fas fa-plus" />
              </span>
              {textButton}
            </Button>
          ) : null}
        </div>
      </div>
      <Row>
        <Col xs={12} className="text-center">
          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable data={data} columns={columns} options={options} />
          </MuiThemeProvider>
        </Col>
      </Row>
    </ContentWrapper>
  );
}

export default DataTable;
